var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-tree-wrapper"},[_c('div',{staticClass:"file-item",class:{ 
      'folder-item': _vm.file.isDirectory 
    },on:{"click":_vm.handleClick}},[(_vm.file.isDirectory)?_c('i',{staticClass:"file-icon folder-closed"}):_vm._e(),_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(_vm.file.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }